import type * as React from 'react'
import { Field } from '@/components/ui/Field'
import { Textarea } from '@/components/ui/Textarea'
import type { FieldBinding } from './types'

interface TextareaFieldProps<T extends object>
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'name' | 'value' | 'form'>,
    FieldBinding<T> {
  label?: React.ReactNode
  hint?: React.ReactNode
  required?: boolean
  className?: string
}

export function TextareaField<T extends object>({
  form,
  name,
  label,
  hint,
  required,
  className,
  ...rest
}: TextareaFieldProps<T>) {
  const error = form.errors[name]

  return (
    <Field label={label} hint={hint} error={error} required={required} htmlFor={name} className={className}>
      <Textarea
        {...rest}
        id={name}
        value={String(form.data[name] ?? '')}
        onChange={(event) => form.setData(name, event.target.value as T[keyof T & string])}
        aria-invalid={!!error}
        aria-describedby={error ? `${name}-error` : hint ? `${name}-hint` : undefined}
      />
    </Field>
  )
}
